import { useState } from "react";
import {
  User,
  Bell,
  Lock,
  Palette,
  Globe,
  HelpCircle,
  LogOut,
} from "lucide-react";
import { MobileHeader } from "../components/MobileHeader";
import { MobileCard } from "../components/MobileCard";

type RowProps = {
  icon: typeof User;
  iconBg: string;
  iconColor: string;
  label: string;
  desc?: string;
  right?: React.ReactNode;
};

/**
 * 設定行の 1 行（アイコン + ラベル + 説明 + 右側アクション）
 */
const SettingsRow = ({
  icon: Icon,
  iconBg,
  iconColor,
  label,
  desc,
  right,
}: RowProps) => (
  <div className="mobile-settings-row">
    <div className="mobile-settings-row-left">
      <div
        className="mobile-settings-row-icon"
        style={{ background: iconBg, color: iconColor }}
      >
        <Icon size={18} strokeWidth={2} />
      </div>
      <div>
        <div className="mobile-settings-row-label">{label}</div>
        {desc && <div className="mobile-settings-row-desc">{desc}</div>}
      </div>
    </div>
    {right}
  </div>
);

type ToggleProps = {
  initial?: boolean;
};

/**
 * iOS 風のトグルスイッチ
 */
const Toggle = ({ initial = false }: ToggleProps) => {
  const [on, setOn] = useState(initial);
  return (
    <button
      type="button"
      className={`mobile-switch ${on ? "on" : ""}`}
      onClick={() => setOn((v) => !v)}
      aria-pressed={on}
      aria-label="切り替え"
    >
      <span className="mobile-switch-knob" />
    </button>
  );
};

/**
 * モバイル設定ページ
 * プロフィール / 通知 / セキュリティ / 表示 / 言語 / ヘルプ / ログアウト
 */
export const MobileSettingsPage = () => {
  return (
    <>
      <MobileHeader title="設定" />
      <main className="mobile-content">
        <MobileCard>
          <SettingsRow
            icon={User}
            iconBg="#eff6ff"
            iconColor="#2563eb"
            label="プロフィール"
            desc="山田 太郎 / 管理者"
            right={<span style={{ color: "#94a3b8", fontSize: 18 }}>›</span>}
          />
          <SettingsRow
            icon={Bell}
            iconBg="#fef3c7"
            iconColor="#f59e0b"
            label="通知"
            desc="プッシュ通知 / メール"
            right={<Toggle initial />}
          />
          <SettingsRow
            icon={Lock}
            iconBg="#fee2e2"
            iconColor="#ef4444"
            label="セキュリティ"
            desc="二段階認証"
            right={<Toggle />}
          />
          <SettingsRow
            icon={Palette}
            iconBg="#f5f3ff"
            iconColor="#7c3aed"
            label="テーマ"
            desc="ブルー (現在)"
            right={<span style={{ color: "#94a3b8", fontSize: 18 }}>›</span>}
          />
          <SettingsRow
            icon={Globe}
            iconBg="#dcfce7"
            iconColor="#16a34a"
            label="言語"
            desc="日本語"
            right={<span style={{ color: "#94a3b8", fontSize: 18 }}>›</span>}
          />
          <SettingsRow
            icon={HelpCircle}
            iconBg="#f1f5f9"
            iconColor="#475569"
            label="ヘルプ / お問い合わせ"
            right={<span style={{ color: "#94a3b8", fontSize: 18 }}>›</span>}
          />
        </MobileCard>

        <button
          type="button"
          className="mobile-btn mobile-btn-secondary mobile-btn-block"
          style={{ color: "#ef4444", fontWeight: 700 }}
        >
          <LogOut size={16} strokeWidth={2} />
          ログアウト
        </button>

        <div
          style={{
            textAlign: "center",
            fontSize: 11,
            color: "#94a3b8",
            fontWeight: 600,
            padding: "8px 0 0 0",
          }}
        >
          統合ポータル v0.1.0 (Mobile Demo)
        </div>
      </main>
    </>
  );
};
